import Tooltip from 'components/tooltip/Tooltip';
import { IconLink } from './CommonHeader.styles';

const HeaderIconButton = ({
  id,
  icon,
  text,
  href,
  onClick,
  openSameTab,
}: {
  id: string;
  icon: React.ReactNode;
  text: string;
  href: string;
  onClick?: () => void;
  openSameTab?: boolean;
}) => {
  return (
    <Tooltip id={id} text={text}>
      <IconLink
        data-testid={id}
        to={href}
        target={openSameTab ? undefined : '_blank'}
        onClick={onClick}
      >
        {icon}
      </IconLink>
    </Tooltip>
  );
};

HeaderIconButton.defaultProps = {
  openSameTab: false,
  onClick: () => {},
};

export default HeaderIconButton;
